import { colors, radii, typography as typographyTokens } from '@components/design-system/tokens';
import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme: any) => ({
    wrapper: {
        width: '100%',
        borderRadius: `${radii.lg}px`,
        border: `1px solid ${colors.neutral[200]}`,
        backgroundColor: colors.neutral[0],
        overflow: 'hidden',
    },
    loadingIndicator: {
        height: '100%',
        minHeight: '200px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    container: {
        scrollbarWidth: 'thin',

        '&::-webkit-scrollbar': {
            width: 6,
            height: 6,
        },

        '&::-webkit-scrollbar-track': {
            background: colors.neutral[100],
        },

        '&::-webkit-scrollbar-thumb': {
            background: colors.neutral[300],
            borderRadius: 3,
        },

        '& tr': {
            [theme.breakpoints.down('md')]: {
                fontSize: typographyTokens.fontSize.xs,
            },
        },

        '& th': {
            padding: '12px 16px',
            backgroundColor: colors.neutral[50],
            color: colors.neutral[700],
            fontWeight: typographyTokens.fontWeight.semibold,
            fontSize: typographyTokens.fontSize.sm,
            borderBottom: `1px solid ${colors.neutral[200]}`,
            whiteSpace: 'nowrap',

            [theme.breakpoints.down('md')]: {
                padding: '8px 12px',
                fontSize: typographyTokens.fontSize.xs,
            },
        },

        '& td': {
            padding: '10px 16px',
            fontSize: typographyTokens.fontSize.sm,
            color: colors.neutral[900],
            borderBottom: `1px solid ${colors.neutral[100]}`,

            [theme.breakpoints.down('md')]: {
                padding: '8px 12px',
                fontSize: typographyTokens.fontSize.xs,
            },
        },
    },
    lastChildFixed: {
        '& th': {
            '&:last-child': {
                position: 'sticky',
                right: 0,
                zIndex: 3,
            },
        },

        '& td': {
            '&:last-child': {
                position: 'sticky',
                right: 0,
            },
        },
    },
    firstChildFixed: {
        '& th': {
            '&:first-child': {
                position: 'sticky',
                left: 0,
                zIndex: 3,
            },
        },

        '& td': {
            '&:first-child': {
                position: 'sticky',
                left: 0,
            },
        },
    },
    button: {
        backgroundColor: colors.primary[500],
        color: colors.neutral[0],
        textTransform: 'none',
    },
    toggleButton: {
        '& .MuiToggleButton-root.Mui-selected': {
            backgroundColor: colors.primary[500],
        },
    },
    tableHeaderCell: {
        whiteSpace: 'nowrap',
        alignContent: 'center',
        alignItems: 'center',
        display: 'flex',
    },
    tableHeaderSortIcon: {
        padding: 4,
        marginLeft: 4,
    },
    tableRow: {
        transition: 'background-color 150ms ease',

        '&:hover': {
            backgroundColor: colors.neutral[50],
        },

        '&:nth-of-type(even)': {
            backgroundColor: '#fafafa',
        },
    },
    tableFooter: {
        position: 'sticky',
        bottom: 0,

        '& td': {
            position: 'sticky',
            bottom: 0,
            backgroundColor: colors.neutral[100],
            fontWeight: typographyTokens.fontWeight.semibold,
            color: colors.neutral[700],
            fontSize: typographyTokens.fontSize.sm,
            borderTop: `1px solid ${colors.neutral[200]}`,
        },
    },
}));
